import type { RouteRecordRaw } from "vue-router";

export const helpRoutes: RouteRecordRaw = {
    path: '/help',
    children: [
        {
            path: '',
            name: 'Help & Support',
            component: () => import('@/modules/help/HelpPage.vue'),
            meta: { defaultLayout: true }
        },
        {
            path: 'tickets/:ticketId',
            name: 'Ticket Details',
            component: () => import('@/modules/help/HelpTicketDetails.vue')
        },
        {
            path: 'upload',
            name: 'Upload Migration',
            component: () => import('@/modules/help/HelpUpload.vue')
        }
    ]
};